export default {
  setOTPCode(state, code) {
    state.OTPCode = code;
  },
  setOTPCodeErrorMsg(state, OTPCodeErrorMsg) {
    state.OTPCodeErrorMsg = OTPCodeErrorMsg;
  },
};
